
import React from 'react';
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

interface CompanyLogoUploadProps {
  logoPreview: string | null;
  companyLogoUrl?: string;
  onFileChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isUploading: boolean;
}

export const CompanyLogoUpload = ({ logoPreview, companyLogoUrl, onFileChange, isUploading }: CompanyLogoUploadProps) => {
  return (
    <div className="space-y-2">
      <Label>شعار الشركة</Label>
      <div className="flex items-center gap-4">
        {logoPreview ? (
          <img src={logoPreview} alt="Logo Preview" className="w-16 h-16 rounded-md object-contain border bg-white" />
        ) : companyLogoUrl ? (
          <img src={companyLogoUrl} alt="Logo" className="w-16 h-16 rounded-md object-contain border bg-white" />
        ) : (
          <div className="w-16 h-16 rounded-md bg-gray-100 flex items-center justify-center text-xs text-gray-500 text-center p-1">لا يوجد شعار</div>
        )}
        <div className="flex-1">
          <Input
            id="logo-upload"
            type="file"
            onChange={onFileChange}
            disabled={isUploading}
            className="text-xs h-9"
            accept="image/*"
          />
          {isUploading && <div className="flex items-center gap-2 text-xs text-blue-600 mt-1"><Loader2 className="w-3 h-3 animate-spin" /> <span>جاري الرفع...</span></div>}
        </div>
      </div>
    </div>
  );
};
